import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'

import mutationMoveBoard from './mutation-move-board.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let [, notify] = useNotifications()

  let [, executeMutationMoveBoard] = useMutation(mutationMoveBoard)

  return async function onSubmit({ args, value, change }) {
    switch (args.type) {
      case 'move_board': {
        let mutationResponse = await executeMutationMoveBoard({
          board_order: args.board_order,
        })

        if (mutationResponse.error) {
          notify(
            notifyError(`Error while moving the board. Please try again later.`)
          )
        }

        reExecuteQuery({ requestPolicy: 'cache-and-network' })

        break
      }

      default:
    }
  }
}
